import { Button, Col, Typography } from "antd";
import React from "react";
import {
  InputSelect,
  InputText,
  InputTimePicker,
  SimpleInputSelectMultiple,
} from "../../../../shared/components";
import Upload from "../../../../shared/components/ui/inputs/Upload";
import { useCreateRulesSushiLunch } from "../../hooks";
import { IRulesSushiLunch } from "../../../../redux/@types/rulesSushiLunch";

const { Text } = Typography;
export type SelectedDaysType = Pick<
  IRulesSushiLunch,
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday"
>;
export const RulesSushiLunchForm = ({
  setOpenModalCreate,
}: {
  setOpenModalCreate: (val: boolean) => void;
}) => {
  // Estado inicial de los días (valores como "false" string)
  const [days, setDays] = React.useState<SelectedDaysType>({
    monday: "false",
    tuesday: "false",
    wednesday: "false",
    thursday: "false",
    friday: "false",
    saturday: "false",
    sunday: "false",
  });
  const { control, handleSubmit, setValue } = useCreateRulesSushiLunch({
    setOpenModalCreate,
    days,
  });

  const [selectedDays, setSelectedDays] = React.useState<string[]>([]);

  // Manejar cambios en los días seleccionados
  const handleDaysChange = (values: string[]) => {
    setSelectedDays(values);

    // Actualizar los días en el estado `days` con base en los valores seleccionados
    const updatedDays: SelectedDaysType = {
      monday: values.includes("monday") ? "true" : "false",
      tuesday: values.includes("tuesday") ? "true" : "false",
      wednesday: values.includes("wednesday") ? "true" : "false",
      thursday: values.includes("thursday") ? "true" : "false",
      friday: values.includes("friday") ? "true" : "false",
      saturday: values.includes("saturday") ? "true" : "false",
      sunday: values.includes("sunday") ? "true" : "false",
    };
    setDays(updatedDays);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Nombre:</Text>
        <InputText
          placeHolder="Nombre de la regla"
          name="name"
          control={control}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Días disponibles:</Text>
        <SimpleInputSelectMultiple
          label="Selecciona los días"
          valuesSelect={selectedDays}
          onChange={handleDaysChange}
          clearValue={(value: string) =>
            handleDaysChange(selectedDays.filter((day) => day !== value))
          }
          showSearch={true}
          dataOptions={[
            { title: "Lunes", value: "monday" },
            { title: "Martes", value: "tuesday" },
            { title: "Miércoles", value: "wednesday" },
            { title: "Jueves", value: "thursday" },
            { title: "Viernes", value: "friday" },
            { title: "Sábado", value: "saturday" },
            { title: "Domingo", value: "sunday" },
          ]}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Aplica a:</Text>
        <InputSelect
          name="apply_to"
          control={control}
          dataOptions={[
            { title: "Premium", value: "premiun" },
            { title: "Normal", value: "normal" },
          ]}
          label="Aplica a"
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Hora inicio:</Text>
        <InputTimePicker
          placeHolder="Seleccione hora de inicio"
          name="start_time"
          control={control}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Hora fin:</Text>
        <InputTimePicker
          placeHolder="Seleccione hora de fin"
          name="end_time"
          control={control}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Banner:</Text>
        <Upload
          filePath="sushi-lunch-banners"
          placeHolder="Cargar Banner"
          onUploadedFile={(file) => {
            setValue("banner_path", file.fileKey);
          }}
        />
      </Col>
      <Button
        htmlType="submit"
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
      >
        Crear
      </Button>
    </form>
  );
};
